/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Session_ExpiredInputs */

const en_us2_auth_session_expired = /** @type {(inputs: Auth_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session has expired. Sign in again.`)
};

const pt_br2_auth_session_expired = /** @type {(inputs: Auth_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua sessão expirou. Entre novamente.`)
};

const es_419_auth_session_expired = /** @type {(inputs: Auth_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu sesión expiró. Inicia sesión de nuevo.`)
};

const pt_pt2_auth_session_expired = /** @type {(inputs: Auth_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua sessão expirou. Inicia sessão novamente.`)
};

const fr_fr2_auth_session_expired = /** @type {(inputs: Auth_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta session a expiré. Reconnecte-toi.`)
};

const de_de2_auth_session_expired = /** @type {(inputs: Auth_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Sitzung ist abgelaufen. Melde dich erneut an.`)
};

const it_it2_auth_session_expired = /** @type {(inputs: Auth_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua sessione è scaduta. Accedi di nuovo.`)
};

/**
* | output |
* | --- |
* | "Your session has expired. Sign in again." |
*
* @param {Auth_Session_ExpiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_session_expired = /** @type {((inputs?: Auth_Session_ExpiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Session_ExpiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_session_expired(inputs)
	if (locale === "es-419") return es_419_auth_session_expired(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_session_expired(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_session_expired(inputs)
	if (locale === "de-DE") return de_de2_auth_session_expired(inputs)
	if (locale === "it-IT") return it_it2_auth_session_expired(inputs)
	return en_us2_auth_session_expired(inputs)
});
export { auth_session_expired as "auth.session_expired" }